const initReceiptRaffle = {
  receiptData: {},
  isModalGetReceiptFormOpen: false,
  isModalPushReceiptFormOpen: false,
  isFormLoading: false,
};

export const receiptRaffleReducer = (
  state = initReceiptRaffle,
  action: any
) => {
  if (action.type === "SET_RECEIPT_DATA") {
    return {
      ...state,
      receiptData: action.value,
    };
  }
  if (action.type === "SET_MODAL_GET_RECEIPT_FORM") {
    return {
      ...state,
      isModalGetReceiptFormOpen: action.value,
    };
  }
  if (action.type === "SET_MODAL_PUSH_RECEIPT_FORM") {
    return {
      ...state,
      isModalPushReceiptFormOpen: action.value,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
